import { connect } from 'react-redux';
import { PartialRepaymentComponent } from './../../components/PartialRepayment/PartialRepaymentComponent';

const mapStateToProps = state => (state);
const mapDispatchToProps = dispatch => ({
  onChangeInput: (field, value) => {
    dispatch({ type: 'UPDATE_INPUT', payload: { field, value } });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PartialRepaymentComponent);



// WEBPACK FOOTER //
// ./src/containers/PartialRepayment/PartialRepayment.js